import { Divider, Icon, Typography, VStack } from '@vivaahealth/design-system';
import { useTranslation } from 'react-i18next';
import React from 'react';

import * as api from '../../../api';
import TextData from '../../../components/TextData';
import { constructAddress } from '../../../utils/practice';
import Row from '../../../components/Row';

interface PharmacyProps {
  field: api.PrevisitFormField.PrevisitFormFieldWithConfig;
}

const Pharmacy = ({ field }: PharmacyProps) => {
  const { t } = useTranslation('review');

  const pharmacies = JSON.parse(field.value) as api.Pharmacy.PrevisitPharmacy[];

  return (
    <VStack gap={16}>
      {pharmacies.map(({ id, address, name }, index) => (
        <React.Fragment key={id}>
          <Typography bold variant="headline-small">
            {name}
          </Typography>
          {address && (
            <Row Icon={Icon.MapPin}>
              <TextData
                label={t('pharmacyAddress')}
                value={constructAddress(address)}
              />
            </Row>
          )}
          {index !== pharmacies.length - 1 && <Divider />}
        </React.Fragment>
      ))}
    </VStack>
  );
};

export default Pharmacy;
